export function getPersistenceApiUrl(config) {
  const persistenceApiUrl = String(config?.PERSISTENCE_API_URL || "").replace(/\/+$/, "");
  if (!persistenceApiUrl) {
    throw new Error("PERSISTENCE_API_URL is not configured.");
  }
  return persistenceApiUrl;
}

export function normalizeResolvedMediaUrl(url, protocol = "https:") {
  if (typeof url !== "string" || !url.startsWith("//")) {
    return url;
  }

  return `${protocol}${url}`;
}

export function normalizeResolvedMediaResponse(result, protocol = "https:") {
  if (!result || typeof result !== "object") {
    return result;
  }

  return {
    ...result,
    origin: normalizeResolvedMediaUrl(result.origin, protocol),
    origin_audio: normalizeResolvedMediaUrl(result.origin_audio, protocol)
  };
}

export function cacheRequest(cache, key, request) {
  cache.set(key, request);
  request.catch(() => {
    if (cache.get(key) === request) {
      cache.delete(key);
    }
  });
  return request;
}
